
import React, {useCallback, useEffect, useState} from 'react'
import {useDropzone} from 'react-dropzone'
import PdfComp from './PdfComp'
import Knoppie from './Knoppie'
import Grid from './Grid'
import {
UploadFiles_URL,
loadContract_URL,
LOADID_URL,
LOADOTHER_URL,
LOADIOD_OTHER_URL,
LOADIMAGE_URL,
LOADSTOCKIMAGE_URL
}from '../config'
import useAuth from '../hooks/useAuth';
function MyUploader({className,type,id}) {
  const auth = useAuth();
  const accessToken = auth.auth.accessToken

  const [files,setFiles] =useState([])
  const [rejected,setRejected] =useState([])
  const [loadURL,setLoadURL] = useState(UploadFiles_URL)
  const [message, setMessage] = useState()
  const [loading, setLoading] = useState(false);

  console.log(type)
  console.log(id)
useEffect(()=>{
  if(type==="Employee Contract"){
    setLoadURL(loadContract_URL)
  }else if (type === "Employee ID"){
    setLoadURL(LOADID_URL)
  }else if (type === "Employee Other"){
    setLoadURL(LOADOTHER_URL)
  }else if (type === "Employee Avatar"){
    setLoadURL(LOADIMAGE_URL)
  }else if (type === "Stockitem Image"){
    setLoadURL(LOADSTOCKIMAGE_URL)
  }else if (type === "IOD Other"){
    setLoadURL(LOADIOD_OTHER_URL)
  }else{
    setLoadURL(UploadFiles_URL)
  }
},[])



  const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
console.log(acceptedFiles)
    if(acceptedFiles?.length){

      acceptedFiles.map(file=>console.log(file.name))
      setFiles(previousFiles=>[
        ...previousFiles,
        ...acceptedFiles.map(file=>
        
          Object.assign(file, {preview: URL.createObjectURL(file)})
        )
      ])
    }
    
    if(rejectedFiles?.length){

      rejectedFiles.map(file=>console.log(file.name))
      setRejected(previousFiles=>[
        ...previousFiles,
        ...rejectedFiles
      ])
    }

  }, [])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    accept: {

     
      // 'application/pdf': ['.pdf']
      
    },
    maxSize: 1024*5*1000
  })

  const removeFile = name => {
      console.log("gekliek "+name)
      setFiles(files=>files.filter(file=>file.name !== name))
    
  
  }

  const handleSubmit = async (e) =>{
    e.preventDefault()
    
    if(!files?.length) return
    
    setLoading(true)
    const formdata = new FormData()

    files.forEach(file => formdata.append('file', file));

    formdata.append("type", "filetype")
    console.log(UploadFiles_URL)
    console.log(formdata)
    console.log(loadURL +`/${id}`)
    console.log(accessToken?"there is a accestoken":"No Accesstoken detected")
    const data = await fetch(loadURL +`/${id}`,{
      method:'POST',
      
      headers: {
  
        'Authorization': 'Bearer ' + accessToken

      },
      body: formdata
     
    })

    const responsedata = await data.json()
    console.log(responsedata.message)

    setFiles([])
    setMessage(responsedata.message)
    setLoading(false)



  }

  console.log(message)
  console.log(files)
  return (
    <form>
    <div {...getRootProps({
      className
    })}>
      <input {...getInputProps()} />
      {
        isDragActive ?
          <p>Drop the files here ...</p> :
          <p>Drag 'n' drop some files here, or click to select files</p>
      }
    </div>
      <Knoppie
      text={"submit"}
      callback={handleSubmit}  ></Knoppie>

      {message?
      
        message.map(line=>(

          <div>{line}</div>
        ))
    
    
      :""}

      <div>
     {loading?( <div>...Loading</div>):(
     <>
     <Grid
     header={"Accepted Files Grid"}>
     {files.map(file=>(
       
       <div className='fileList' >

         {file.type!=="application/pdf" ?<img src={file.preview} width={50} height={100}/>:
         
         <div className='smallPDF'>
         <PdfComp
           pdffile={file}
           small={true}
         ></PdfComp>
         </div>
         }
         <div className='NameandButton'>
           {file.name}
         <Knoppie
           text={"remove"}
           callback={()=>removeFile(file.name)}
           ></Knoppie>
         </div>
       </div>
      
     ))}

     </Grid>
     <Grid
     header={"Rejected Files Grid"}>
     {rejected.map(file=>(
       
       <div className='fileList' >

         
         <div className='NameandButton'>
           {file.name}
         <Knoppie
           text={"remove"}
           callback={()=>removeFile(file.name)}
           ></Knoppie>
         </div>
       </div>
      
     ))}

     </Grid>
     </>
     )
     }   
        
      </div>
      
    </form>
  )
}

export default MyUploader